<template>
  <div>
    <div
      class="container-top mt-5"
      :class="{ 'container-medium': lgAndUp || xlAndUp }"
    >
      <div class="row d-md-flex justify-content-between  mb-5">
        <div class="col-md-12">
          <div class="text-head h2  font-weight-bold">
            Custom Field Setup
          </div>
          <div @click="goBack">
            <span class="s-18 fw-400 cursor-pointer text-black">
              <img src="../../assets/gobacck.png" class="w-12 h-12" alt="" /> Go
              back</span
            >
          </div>
        </div>
      </div>

      <div class="row pt-1 pb-5">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12 py-5 bg-gray-200 border-radius-8">
                  <div class="row d-flex justify-content-center">
                    <div class="col-md-10">
                      <div class="col-md-12 col-sm-12">
                        <label for="" class="fw-500 text-dak">
                          Specify Your Label here..</label
                        >
                        <el-input
                          type="text"
                          class="w-100"
                          placeholder="Specify Your Label here.."
                          v-model="customFieldLabel"
                        />
                      </div>
                      <div class="col-md-12 col-sm-12 mt-4">
                        <label for="" class="text-dak fw-500"
                          >Select the type of control you want to use</label
                        >
                        <el-select-v2
                          v-model="selectedControlID"
                          @change="setselectedControl"
                          :options="
                            controlType.map((i) => ({
                              label: i.name,
                              value: i.id,
                            }))
                          "
                          placeholder="Select type"
                          class="w-100"
                          size="large"
                        />
                      </div>
                      <div
                        class="col-md-12 col-sm-12 mt-4 w-100"
                        v-if="selectedControl.name == 'DropdownList'"
                      >
                        <label for="" class="text-dak fw-500">
                          Enter your Dropdown list here
                        </label>
                        <div class="row justify-content-center">
                          <div class="col-md-12">
                            <div class="chip-container col-md-12 p-0 m-0">
                              <div
                                class="chip px-2 d-flex justify-content-between my-2 mx-1"
                                v-for="(chip, i) of dropdownList"
                                :key="chip.label"
                              >
                                <span>{{ chip }}</span>
                                <i
                                  class="pt-1 text-dark align-items-center"
                                  @click="deleteChip(i)"
                                  ><el-icon> <CircleClose /> </el-icon
                                ></i>
                              </div>
                              <input
                                class="inputt py-2"
                                v-model="currentInput"
                                @keypress.enter="saveChip"
                                @input="checkComma"
                                @keydown.delete="backspaceDelete"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-md-12 col-sm-12 mt-4 w-100"
                        v-if="selectedControl.name == 'MultiSelectDropdownList'"
                      >
                        <label for="" class="text-dak fw-500">
                          Enter your MultiSelectDropdownList options here
                        </label>
                        <div class="row justify-content-center">
                          <div class="col-md-12">
                            <div class="chip-container col-md-12 p-0 m-0">
                              <div
                                class="chip px-2 d-flex justify-content-between my-2 mx-1"
                                v-for="(chip, i) of dropdownList"
                                :key="chip.label"
                              >
                                <span>{{ chip }}</span>
                                <i
                                  class="pt-1 text-dark align-items-center"
                                  @click="deleteChip(i)"
                                  ><el-icon> <CircleClose /> </el-icon
                                ></i>
                              </div>
                              <input
                                class="inputt py-2"
                                v-model="currentInput"
                                @keypress.enter="saveChip"
                                @input="checkComma"
                                @keydown.delete="backspaceDelete"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-sm-12 mt-4">
                        <label for="" class="text-dak fw-500"
                          >Select the Entity Type you want to Extend
                        </label>
                        <el-select-v2
                          v-model="selectedEntityTypeID"
                          @change="setselectedEntityType"
                          :options="
                            entityType.map((i) => ({
                              label: i.name,
                              value: i.id,
                            }))
                          "
                          placeholder="Select type"
                          class="w-100"
                          size="large"
                          style="width: 100%; text-align: left"
                        />
                      </div>
                      <div class="col-md-12 col-sm-12 mt-3">
                        <el-checkbox
                          v-model="isRequired"
                          label="This field is required"
                        >
                          Make this field required
                        </el-checkbox>
                      </div>
                      <div
                        class="col-md-12 d-flex justify-content-end mt-3 col-sm-3"
                        @click="saveCustomFields"
                      >
                        <div class="col-md-3">
                          <el-button
                            :color="primarycolor"
                            round
                            class="w-100"
                            size="large"
                            :loading="loading"
                          >
                            Save
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row table-header-row py-3 pl-2 mt-5">
            <div class="col-md-2">
              <span class="py-2 fw-500 s-14">Label</span>
            </div>
            <div class="col-md-3 text-center">
              <span class="py-2 fw-500 s-14">Control Type</span>
            </div>
            <div class="col-md-3 text-center">
              <span class="py-2 fw-500 s-14">Entity Type</span>
            </div>
            <div class="col-md-4 text-center">
              <span class="py-2 fw-500 s-14 mr-md-3 mr-0">Action</span>
            </div>
          </div>
          <!-- :disabled="!enabled" -->
          <!-- <div> {{ index }} - {{ element.label }} </div> -->

          <div
            style="height: 50rem; overflow: auto"
            class="row justify-content-center"
          >
            <div class="col-11 col-sm-12 border">
              <draggable
                item-key="id"
                class="list-group"
                v-model="allCustomFieldList"
                ghost-class="ghost"
                handle=".drag-handle"
                @start="dragging = true"
                @end="(dragging = false), reorderCustomField()"
                v-loading="reoderloading"
              >
                <template #item="{ element, index }">
                  <div class="row py-2 draggable-item">
                    <div class="col-md-12">
                      <div class="row">
                        <div
                          class="col-md-3 d-flex px-md-0 px-3 justify-content-between align-items-center mb-md-0 mb-5 flex-wrap"
                        >
                          <span class="py-2 hidden-header">LABEL:</span>
                          <span
                            class="py-2 text-sm-left mr-md-0 ml-0 ml-md-3 font-text"
                            >{{ element.label }}</span
                          >
                        </div>
                        <div
                          class="col-md-3 d-flex px-md-0 px-3 justify-content-between align-items-center mb-md-0 mb-5 flex-wrap"
                        >
                          <span class="py-2 hidden-header small"
                            >CONTROL TYPE:</span
                          >
                          <span
                            class="py-2 text-sm-end mr-md-0 ml-0 ml-md-3 font-text"
                            >{{ getControlName(element.controlType) }}
                          </span>
                        </div>
                        <div
                          class="col-md-3 d-flex px-md-0 justify-content-between align-items-center mb-md-0 mb-5 flex-wrap"
                        >
                          <span class="py-2 hidden-header">ENTITY TYPE:</span>
                          <span class="py-2 text-sm-end font-text">{{
                            getEntityName(element.entityType)
                          }}</span>
                        </div>
                        <div
                          class="col-md-3 mb-md-0 mb-2 col-12 d-flex justify-content-md-start align-items-center"
                        >
                          <span class="py-md-4 hidden-header hidden-header1"
                            >ACTION</span
                          >
                          <div
                            class="d-flex justify-content-md-between w-100 fllexxwrap"
                          >
                            <el-dropdown class="w-100" trigger="click">
                              <span class="el-dropdown-link">
                                <el-icon>
                                  <MoreFilled />
                                </el-icon>
                              </span>
                              <template #dropdown>
                                <el-dropdown-menu>
                                  <el-dropdown-item
                                    @click="openClassification(index)"
                                    >View</el-dropdown-item
                                  >
                                  <el-dropdown-item
                                    @click="showConfirmModal(element.id, index)"
                                    >Delete</el-dropdown-item
                                  >
                                </el-dropdown-menu>
                              </template>
                            </el-dropdown>
                            <img
                              src="../../assets/drag-and-drop.png"
                              class="drag-handle ms-2"
                              alt="drag"
                            />
                            <!-- <el-button class="py-1 px-4 mb-md-3" color="#EBEFF4" round @click="openClassification(index)">
                          View
                        </el-button>
                        <el-button class="delbtn py-1 primary-btn px-3 mb-md-3"
                          @click="deleteCustomField(element.id, index)" round>
                          Delete
                        </el-button> -->
                          </div>
                        </div>
                      </div>
                      <div
                        class="row grey-background"
                        v-if="vissibleTab === `tab_${index}`"
                      >
                        <div
                          class="col-md-12"
                          :class="{
                            'show-view-dropdown': toggleCustomList,
                            'hide-view-dropdown': !toggleCustomList,
                          }"
                        >
                          <div class="col-md-9 d-flex flex-wrap mt-3">
                            <div class="col-md-4 text-md-right text-left">
                              <label for="">Label</label>
                            </div>
                            <div class="col-md-8">
                              <el-input
                                type="text"
                                class="w-100"
                                v-model="customLabel"
                                size="large"
                              />
                            </div>
                          </div>
                          <div class="col-md-9 d-flex flex-wrap mt-3">
                            <div class="col-md-4 text-md-right text-left">
                              <label for="">Control type</label>
                            </div>
                            <div class="col-md-8">
                              <el-select-v2
                                v-model="customControlTypeID"
                                @change="setcustomControlType"
                                :options="
                                  controlType.map((i) => ({
                                    label: i.name,
                                    value: i.id,
                                  }))
                                "
                                placeholder="Select type"
                                class="w-100"
                                size="large"
                                style="width: 100%; text-align: left"
                              />
                            </div>
                          </div>

                          <div
                            class="col-md-9 d-flex flex-wrap my-3"
                            v-if="customControlType.name == 'DropdownList'"
                          >
                            <div class="col-md-4 text-md-right text-left"></div>
                            <div class="col-md-8">
                              <el-input
                                type="text"
                                class="w-100"
                                size="large"
                                v-model="customDropdownList"
                              />
                            </div>
                          </div>

                          <div class="col-md-9 d-flex flex-wrap my-3">
                            <div class="col-md-4 text-md-right text-left">
                              <label for="">Entity type</label>
                            </div>
                            <div class="col-md-8">
                              <el-select-v2
                                v-model="customEntityTypeID"
                                @change="setcustomEntityType"
                                :options="
                                  entityType.map((i) => ({
                                    label: i.name,
                                    value: i.id,
                                  }))
                                "
                                placeholder="Select type"
                                class="w-100"
                                size="large"
                                style="width: 100%; text-align: left"
                              />
                            </div>
                          </div>
                          <div class="col-md-9 d-flex flex-wrap my-3">
                            <div class="col-md-4"></div>
                            <div class="col-md-8">
                              <el-checkbox
                                v-model="updateIsRequired"
                                label="This field is required"
                              >
                                Make this field required
                              </el-checkbox>
                            </div>
                          </div>
                          <div class="col-md-12">
                            <div class="row mt-0 d-flex justify-content-center">
                              <div class="save-discard-btn">
                                <div class="">
                                  <el-button
                                    class="save-btn text-white py-1 px-4"
                                    round
                                    @click="
                                      updateCustomField(element.id, index)
                                    "
                                  >
                                    Save
                                  </el-button>
                                </div>
                                <div class="">
                                  <el-button
                                    class="secondary-btn py-1 px-3 m bor"
                                    round
                                    color="#EBEFF4"
                                    @click="discard"
                                  >
                                    Discard
                                  </el-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12 px-0">
                          <hr class="hr my-0" />
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </draggable>
            </div>
          </div>

          <div class="col-12 text-center p-5" v-if="loadingfields">
            <i
              class="pi pi-spin pi-spinner text-center text-primary"
              style="font-size: 3rem"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, inject, watchEffect } from "vue";
import axios from "@/gateway/backendapi";
import { ElNotification, ElMessageBox } from "element-plus";
import finish from "../../services/progressbar/progress";
import draggable from "vuedraggable";
import router from "../../router";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";

export default {
  components: {
    draggable,
  },
  setup() {
    const primarycolor = inject("primarycolor");
    const selectedControl = ref({});
    const currentInput = ref("");
    const selectedControlID = ref(null);
    const currentEditingId = ref(null);
    const customControlTypeID = ref(null);
    const customEntityTypeID = ref(null);
    const selectedEntityTypeID = ref(null);
    const dropdownList = ref([]);
    const customDropdownList = ref("");
    const vissibleTab = ref(false);
    const selectedEntityType = ref({});
    const loading = ref(false);
    const loadingfields = ref(false);
    const customEntityType = ref({});
    const customControlType = ref({});
    const customLabel = ref("");
    const customFieldLabel = ref("");
    const tenantId = ref("");
    const getAllcontrolType = ref([]);
    const getAllEntityType = ref([]);
    const allCustomFieldList = ref([]);
    const getCustomizableField = ref([]);
    const toggleCustomList = ref(false);
    const isRequired = ref(false);
    const updateIsRequired = ref(false);
    const controlType = ref([
      { name: "Text", id: 0 },
      { name: "DropdownList", id: 1 },
      { name: "CheckBox", id: 2 },
      { name: "DateTime", id: 3 },
      { name: "Email", id: 4 },
      { name: "Phone", id: 5 },
      // { name: "TextArea", id: 6 },
      { name: "Image", id: 7 },
      { name: "Number", id: 8 },
      // { name: "Name", id: 9 },
      { name: "MultiSelectDropdownList", id: 11 },
    ]);
    const entityType = ref([
      { name: "Member", id: "0" },
      { name: "FirstTimers", id: "1" },
      { name: "NewConverts", id: "2" },
      { name: "Activity", id: "3" },
      { name: "EventRegistrationForm", id: "4" },
      { name: "CheckInAttendance", id: "5" },
    ]);
    const dragging = ref(false);
    const reoderloading = ref(false);

    const goBack = () => router.go(-1);
    const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();

    const saveChip = () => {
      if (!dropdownList.value.includes(currentInput.value)) {
        dropdownList.value.push(currentInput.value);
      }
      currentInput.value = "";
    };
    const deleteChip = (index) => dropdownList.value.splice(index, 1);
    const backspaceDelete = ({ which }) => {
      if (which === 8 && currentInput.value === "") {
        dropdownList.value.pop();
      }
    };
    const checkComma = (e) => {
      if (e.data === ",") saveChip();
    };

    const setcustomEntityType = () => {
      customEntityType.value = entityType.value.find(
        (i) => i.id === customEntityTypeID.value
      );
    };
    const setcustomControlType = () => {
      customControlType.value = controlType.value.find(
        (i) => i.id === customControlTypeID.value
      );
    };
    const setselectedEntityType = () => {
      selectedEntityType.value = entityType.value.find(
        (i) => i.id === selectedEntityTypeID.value
      );
    };
    const setselectedControl = () => {
      selectedControl.value = controlType.value.find(
        (i) => i.id === selectedControlID.value
      );
    };

    const discard = () => {
      currentEditingId.value = null;
      vissibleTab.value = "";
      toggleCustomList.value = !toggleCustomList.value;
    };

    const getAllControls = async () => {
      try {
        await axios.get("/api/CustomFields/GetAllControls");
      } catch (error) {
        console.error(error);
      }
    };
    getAllControls();

    const deleteCustomField = (id) => {
      axios
        .delete(`/api/CustomFields/EditCustomFields?customAttributeID=${id}`)
        .then(() => {
          ElNotification({
            type: "success",
            message: "Custom field deleted",
            duration: 5000,
          });
          allCustomFieldList.value = allCustomFieldList.value.filter(
            (f) => f.id !== id
          );
        })
        .catch((err) => {
          finish();
          ElNotification({
            type: err.response.status === 400 ? "error" : "error",
            message:
              err.response.status === 400
                ? "Ensure this is not in any group"
                : "An error occurred, please try again",
            duration: 5000,
          });
        });
    };

    const showConfirmModal = (id) => {
      ElMessageBox.confirm(
        "Are you sure you want to Delete?",
        "Confirm delete",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "error",
        }
      )
        .then(() => deleteCustomField(id))
        .catch(() => {
          ElNotification({
            type: "info",
            message: "Delete canceled",
            duration: 5000,
          });
        });
    };

    const getCustomizable = async () => {
      try {
        const res = await axios.get("/api/CustomFields/GetCustomizableObjects");
        getCustomizableField.value = res.data;
      } catch (error) {
        console.error(error);
      }
    };
    getCustomizable();

    const getCurrentlySignedInUser = async () => {
      try {
        const res = await axios.get("/api/Membership/GetCurrentSignedInUser");
        tenantId.value = res.data.tenantId;
      } catch (err) {
        console.error(err);
      }
    };
    getCurrentlySignedInUser();

    const openClassification = (index) => {
      const item = allCustomFieldList.value[index];
      if (!item) return;

      currentEditingId.value = item.id; // ← save the actual ID
      vissibleTab.value = `tab_${index}`;
      customLabel.value = item.label;
      customDropdownList.value = item.parameterValues;
      updateIsRequired.value = item.isRequired;

      const matchedControl = controlType.value.find(
        (i) => i.id == item.controlType || i.name === item.controlType
      );

      const matchedEntity = entityType.value.find(
        (i) => i.id == item.entityType || i.name === item.entityType
      );

      customControlType.value = matchedControl || {};
      customControlTypeID.value = matchedControl?.id ?? null;

      customEntityType.value = matchedEntity || {};
      customEntityTypeID.value = matchedEntity?.id ?? null;

      toggleCustomList.value = true;
    };

    const updateCustomField = async () => {
      const customDetail = {
        id: currentEditingId.value, // ← use the real ID now
        entityType: customEntityType.value.id,
        tenantID: tenantId.value,
        label: customLabel.value,
        controlType: customControlType.value.id,
        parameterValues: customDropdownList.value,
        isRequired: updateIsRequired.value,
      };
      try {
        await axios.put("/api/CustomFields/EditCustomFields", customDetail);
        ElNotification({
          type: "success",
          message: "Custom Field Updated successfully",
          duration: 5000,
        });
        getAllCustomFields();
      } catch (err) {
        console.error(err);
      }
      discard();
    };

    const saveCustomFields = async () => {
      // ✅ Validation checks
      if (!customFieldLabel.value?.trim()) {
        ElNotification({
          type: "warning",
          message: "Please enter a label for your custom field",
          duration: 4000,
        });
        return;
      }

      if (!selectedControl.value?.name) {
        ElNotification({
          type: "warning",
          message: "Please select a control type",
          duration: 4000,
        });
        return;
      }

      if (
        (selectedControl.value.name === "DropdownList" ||
          selectedControl.value.name === "MultiSelectDropdownList") &&
        dropdownList.value.length === 0
      ) {
        ElNotification({
          type: "warning",
          message: "Please enter options for your dropdown list",
          duration: 4000,
        });
        return;
      }

      if (!selectedEntityType.value?.name) {
        ElNotification({
          type: "warning",
          message: "Please select an entity type",
          duration: 4000,
        });
        return;
      }
      loading.value = true;
      const body = {
        entityType: selectedEntityType.value.name,
        tenantID: tenantId.value,
        label: customFieldLabel.value,
        parameterValues: dropdownList.value.join(","),
        controlType: selectedControl.value.name,
        isRequired: isRequired.value,
      };
      try {
        await axios.post("/api/CustomFields/SaveCustomFields", body);
        ElNotification({
          type: "success",
          message: "Custom Field created successfully",
          duration: 5000,
        });
        customFieldLabel.value = "";
        selectedControl.value = {};
        selectedControlID.value = null;
        selectedEntityType.value = {};
        selectedEntityTypeID.value = null;
        dropdownList.value = [];
        isRequired.value = false;
        getAllCustomFields();
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    };

    const getAllCustomFields = async () => {
      loadingfields.value = true;
      try {
        const res = await axios.get("/api/CustomFields/GetAllCustomFields");
        allCustomFieldList.value = res.data.sort((a, b) => a.order - b.order);
        getAllcontrolType.value = res.data.map((i) => ({
          name: i.controlType,
          id: i.id,
        }));
        getAllEntityType.value = res.data.map((i) => ({
          name: i.entityType,
          id: i.id,
        }));
      } catch (err) {
        console.error(err);
      } finally {
        loadingfields.value = false;
      }
    };
    getAllCustomFields();

    const getEntityName = (id) =>
      entityType.value.find((i) => i.id == id)?.name || "";
    const getControlName = (id) =>
      controlType.value.find((i) => i.id == id)?.name || "";

    const reorderCustomField = async () => {
      reoderloading.value = true;
      const payload = allCustomFieldList.value.map((i, index) => ({
        ...i,
        order: index,
      }));
      try {
        await axios.post("/api/CustomFields/ReorderCustomFields", payload);
        ElNotification({
          type: "success",
          message: "Custom fields reordered successfully",
          duration: 5000,
        });
      } catch (error) {
        console.error(error);
      } finally {
        reoderloading.value = false;
      }
    };

    return {
      isRequired,
      updateIsRequired,
      currentEditingId,
      controlType,
      mdAndUp,
      lgAndUp,
      xlAndUp,
      xsOnly,
      deleteChip,
      backspaceDelete,
      currentInput,
      saveChip,
      setselectedControl,
      setcustomControlType,
      setcustomEntityType,
      setselectedEntityType,
      selectedControlID,
      customEntityTypeID,
      customControlTypeID,
      selectedEntityTypeID,
      getControlName,
      vissibleTab,
      saveCustomFields,
      showConfirmModal,
      deleteCustomField,
      updateCustomField,
      customEntityType,
      customControlType,
      getAllcontrolType,
      customLabel,
      loading,
      getAllEntityType,
      selectedControl,
      allCustomFieldList,
      getCustomizableField,
      selectedEntityType,
      entityType,
      dropdownList,
      openClassification,
      discard,
      getEntityName,
      customFieldLabel,
      customDropdownList,
      toggleCustomList,
      primarycolor,
      loadingfields,
      reorderCustomField,
      dragging,
      goBack,
      reoderloading,
      checkComma,
    };
  },
};
</script>

<style scoped>
.drag-handle {
  cursor: grab;
  width: 20px;
  height: 20px;
  touch-action: none; /* Prevent accidental scrolling when dragging */
}

.draggable-item {
  user-select: none; /* Prevent text selection during drag */
}
.chip-container {
  /* width: 425px; */
  border: 1px solid #ccc;
  background: #ffffff;
  min-height: 34px;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
}

.chip {
  padding: 0.3rem 0.3rem;
  border: 1px solid #02172e0d;
  border-radius: 25px;
  background: #02172e14;
  /* margin:4px;
    background: #e0e0e0;
    padding:0px 4px;
    border: 1px solid #ccc;
    border-radius: 3px;
    display:flex;
    align-items: center; */
}

i {
  cursor: pointer;
  opacity: 0.56;
  margin-left: 8px;
}

.inputt {
  /* flex: 1 1 auto;
    width: 30px; */
  border: none;
  outline: none;
  padding: 4px;
}

.table-header-row {
  background: #f4f4f4ab;
  /* border-top: 1px solid #dde2e6; */
  border-radius: 8px;
}

.save-discard-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  /* gap: rem; */
}

.show-view-dropdown {
  height: 340px;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}

.hide-view-dropdown {
  height: 0px;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}

.hidden-header {
  display: none;
}

.grey-background {
  background: #dde2e6;
}

.email-destination {
  padding: 0.1rem 0.4rem;
  border: 1px solid #02172e0d;
  border-radius: 8px;
  background: #02172e14;
}

.remove-email {
  color: #000;
  font-weight: bold;
}

.remove-email:hover {
  cursor: pointer;
}

.save-btn {
  background: #50ab00;
}

.delbtn:hover {
  background-color: red !important;
  color: white !important;
}

.delbtn {
  background-color: #f2bc9e !important;
  color: black !important;
}

.delbtn:focus {
  outline: none !important;
  border: none !important;
}

.memCat {
  font: var(--unnamed-font-style-normal) normal 800 34px/46px
    var(--unnamed-font-family-nunito-sans);
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  font: normal normal 800 34px/46px Nunito Sans;
  letter-spacing: 0px;
  color: #02172e;
  opacity: 1;
}

.memCat1 {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    24px/32px var(--unnamed-font-family-nunito-sans);
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  font: normal normal bold 24px/32px Nunito Sans;
  letter-spacing: 0px;
  color: #02172e;
  opacity: 1;
}

@media screen and (max-width: 767px) {
  .hidden-header1 {
    display: none !important;
  }

  .hidden-header {
    display: inline-block;
    font-weight: 700;
    font-size: 13px;
  }

  .table-header-row {
    display: none;
  }

  .bold:hover {
    color: white !important;
  }

  .bold {
    color: rgb(187, 176, 176) !important;
  }

  .bor {
    border: #02172e !important;
  }
}

@media screen and (max-width: 746px) {
  .show-view-dropdown {
    height: 400px;
    overflow: hidden;
    transition: all 0.5s ease-in-out;
  }
}

@media screen and (max-width: 348px) {
  .show-view-dropdown {
    height: 450px;
    overflow: hidden;
    transition: all 0.5s ease-in-out;
  }
}

@media screen and (max-width: 300px) {
  .fllexxwrap {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media screen and (max-width: 390px) {
  .memCat {
    font: var(--unnamed-font-style-normal) normal 500 20px/25px
      var(--unnamed-font-family-nunito-sans);
    letter-spacing: var(--unnamed-character-spacing-0);
    text-align: left;
    font: normal normal 800 20px/25px Nunito Sans;
    letter-spacing: 0px;
    color: #02172e;
    opacity: 1;
  }

  .memCat1 {
    font: var(--unnamed-font-style-normal) normal
      var(--unnamed-font-weight-bold) 18px/20px
      var(--unnamed-font-family-nunito-sans);
    letter-spacing: var(--unnamed-character-spacing-0);
    text-align: left;
    font: normal normal bold 18px/20px Nunito Sans;
    letter-spacing: 0px;
    color: #02172e;
    opacity: 1;
  }

  .save-discard-btn {
    flex-wrap: wrap;
  }

  .font-text {
    font-size: 13px;
    font-weight: bold;
  }
}

.graggable {
  cursor: move;
  /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}
</style>
